// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__XIWtO","content":"FallbackPage_content__g07KR"};